import { createFileRoute } from "@tanstack/react-router";
import { PortalMessagesPage } from "@/features/portalmessages/PortalMessagesPage";

/** P107 Portal messages: the client's shared chat channel (docs/frontend/PAGES.md). */
export const Route = createFileRoute("/portal/messages")({ component: PortalMessagesPage });
